// extracted by mini-css-extract-plugin
module.exports = {"oopsContainer":"ErrorPage-module__oopsContainer___rcAWm","errorMessage":"ErrorPage-module__errorMessage___RYC2c","menu":"ErrorPage-module__menu___cpaNo"};